import gql from 'graphql-tag';

const query = gql`
  query SearchUserMeals($searchCriteria: UserMealsSearchCriteriaInputType) {
    dailyTracker {
      userMeals(searchCriteria: $searchCriteria) {
        edges {
          cursor
          node {
            id
            name
            notes
            calories
            proteinGrams
            carbsGrams
            fatGrams
            isUserMeal
            sourceType
            derivedMealsCount
            imageUrl
          }
        }
      }
    }
  }
`;

export default query;
